module.exports = __webpack_public_path__ + "img/mdl.becbd18e.jpg";